<h3 class="with-manual-link">
  <span i18n="@@changelog">Änderungsverlauf</span>
  <app-manual-link
  href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Changelog"></app-manual-link>
</h3>

<div class="row mt-3">
  <div class="col-3">
    <span i18n="@@change-history">Änderungshistorie</span>
    <app-hint i18n="@@change-history-hint">
      Schreibe hier eine Beschreibung der wichtigsten Änderungen am Bot.
      Andere Administratoren sehen diese im „Information"-Menüpunkt.
    </app-hint>
  </div>
  <div class="col">
    <app-codemirror-ai
      [placeholder]="this.changeHistoryPlaceholder"
      [instruction]="this.rss.botConfig.changeHistory"
      [rows]="15"
      (finish)="this.saveChangeHistory($event)"
    ></app-codemirror-ai>
    <div class="mt-2">
      <p-button
        [loading]="this.isGenerating"
        icon="ri-magic-fill"
        i18n-label="@@generate-change-history"
        label="Mit KI generieren / aktualisieren"
        (onClick)="this.generateWithAI()"
        [outlined]="true"
        severity="secondary"
      ></p-button>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-3">
    <span i18n="@@show-as-menu-item">Als Menüpunkt anzeigen</span>
    <app-hint i18n="@@show-as-menu-item-hint">
      Wenn aktiviert, erscheint ein „Information"-Menüpunkt im Bot und zeigt die Änderungshistorie an.
      Beim Öffnen des Bots wird dieser Menüpunkt standardmäßig aktiv sein.
    </app-hint>
  </div>
  <div class="col d-flex align-items-center">
    <p-toggleswitch
      [(ngModel)]="this.rss.botConfig.showChangeHistory"
      (onChange)="this.toggleShowChangeHistory()"
    />
  </div>
</div>

<hr class="mt-4 mb-3">
<h5 i18n="@@automatic-changelog">Automatisches Änderungsprotokoll</h5>

<p-table
  [value]="this.changeLogService.changeLog"
  [rowHover]="true"
>
  <ng-template
    pTemplate="body"
    let-item
  >
    <tr>
      <td>
        {{ item.user }}<br>
        <p-tag
          styleClass="changelog-time-tag"
          severity="secondary"
          [value]="dayjs(item.created).fromNow()"
        ></p-tag>
      </td>
      @if (item.field !== 'botPassword') {
        <td
          style="word-break: break-all;"
          >
          {{ item.field }}: {{item.value | shorty: 200}}
          @if (item.value.length > 200) {
            <p-button
              size="small"
              [text]="true"
              icon="ri-information-2-line"
              (onClick)="openModal(moreInfo, item)"
            ></p-button>
          }
        </td>
      }
      @if (item.field === 'botPassword') {
        <td
          style="word-break: break-all;"
          >
          {{ item.field }}: <span class="text-blur">{{item.value | shorty: 200}}</span>
        </td>
      }
    </tr>
  </ng-template>
</p-table>
<ng-template #moreInfo>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ this.selectedItem?.field }}</h4>
    <p-button
      [text]="true"
      [rounded]="true"
      icon="pi pi-times"
      (onClick)="this.selectedItem = undefined; this.modalRef?.hide()"
      ariaLabel="Close"
    ></p-button>
  </div>
  <div
    class="modal-body"
    style="height: 300px; overflow: scroll;"
    >
    {{ this.selectedItem?.value }}
  </div>
</ng-template>